import { render, staticRenderFns } from "./Skillcheck.vue?vue&type=template&id=6901b992&scoped=true"
import script from "./Skillcheck.vue?vue&type=script&lang=js"
export * from "./Skillcheck.vue?vue&type=script&lang=js"
import style0 from "./Skillcheck.vue?vue&type=style&index=0&id=6901b992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6901b992",
  null
  
)

export default component.exports